// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"12034a80","69":"37cf7277","360":"d52cf475","453":"03346f77","482":"e846054d","610":"09002d9d","890":"13ea0b7b"}[chunkId] + ".chunk.js";
};